export default __webpack_public_path__ + "static/media/cart-icon.1fdc0147.svg";